//https://www.npmjs.com/package/vue-ripple-directive
import Vue from 'vue'
import Ripple from 'vue-ripple-directive'

Vue.directive('ripple', Ripple);
